import { ConfirmationDialogStyled } from './ConfirmationDialog'
import { PrimaryBtnOutline, PrimaryButton } from '../Buttons'
import { useTranslation } from 'react-i18next'
import { useHRRequestHelp } from '../../hooks/useHRRequestHelp'

interface HelpRequestModalProps {
    isActive: boolean
    onClose: () => void
    onComplete: () => void
}

const HelpRequestModal = ({ isActive, onClose, onComplete }: HelpRequestModalProps) => {
    const { t } = useTranslation('meeting')
    const { requestHelp } = useHRRequestHelp({ onComplete })

    const handleSubmit = () => {
        requestHelp()
        onClose()
    }

    return (
        <ConfirmationDialogStyled>
            <div className="info">
                <h2>{t('helpRequest.modal.title')}</h2>
                <p>{t('helpRequest.modal.copy')}</p>
            </div>

            <div className="actions">
                <PrimaryButton onClick={handleSubmit}>{t('helpRequest.modal.submit')}</PrimaryButton>
                <PrimaryBtnOutline onClick={onClose} colorTheme="light">
                    {t('helpRequest.modal.cancel')}
                </PrimaryBtnOutline>
            </div>
        </ConfirmationDialogStyled>
    )
}

export default HelpRequestModal
